import * as Yup from "yup";
export const NotificationShema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  time: Yup.string().min(5, "Invalid time").required("Time is required"),
});
